import React, { useState, useEffect } from 'react'
import {
  Panel,
  Message,
  Row,
  Input,
  ControlLabel,
  Col,
  Table,
  IconButton,
  Icon,
  ButtonToolbar,
  SelectPicker,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import InputForm from '../../../components/forms/input/InputForm'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { useHistory } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import {
  exportConfirmActualResult,
  exportVender,
  getConfirmActualResult,
  searchProjectVender,
} from '../../../redux/actions/adminReport'
import { downloadFile } from '../../../utils/fileUtil'

export default function ConfirmActualResultWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const { Column, HeaderCell, Cell, Pagination } = Table
  const history = useHistory()
  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 30, label: 30 },
    { value: 40, label: 40 },
    { value: 50, label: 50 },
  ]

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState()
  const [errorMsg, setErrorMsg] = useState()
  const [condition, setCondition] = useState()
  const [pagSize, setPagSize] = useState(10)
  const [clearValue, setClearValue] = useState(false)
  const [lengthMenu, setLengthMenu] = useState()
  const [page, setPage] = useState(1)
  const [displayLength, setDisplayLength] = useState(formSchema.displayLength || 10)
  const [viewSize, setViewSize] = useState([])

  useEffect(() => {
    console.log('formSchema => ', formSchema)
    setDataTable(props.schema.values)
    setViewSize(defaultLengthMenu)
  }, [])

  const onSubmit = (data) => {
    console.log('onSubmit => ', data)

    // return false

    callApiSearch(data.projectCode, data.projectName, 1, 10)
  }

  const onCancel = (data) => {
    callApiSearch('', '', 1, 10)

    setValue(formSchema.search.projectCode.name, '')
    setValue(formSchema.search.projectName.name, '')
  }

  const callApiSearch = async (projectCode, projectName, pageNumber, pageSize) => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getConfirmActualResult(projectCode, projectName, pageNumber, pageSize)
      console.log('schema ', _schema.forms)
      setDataTable(_schema?.forms?.values || [])

      // {formSchema.displayLength}
      //     <br />
      //     {formSchema.totalSize}
      // setDisplayLength(_schema?.forms?.totalSize || 1)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey)
    }
  }

  const handleChangeLength = (dataKey) => {
    console.log('handleChangeLength => ', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1)
    }
  }

  const onReload = (display, pages) => {
    console.log('onReload => ', display, pages)
    setValue(formSchema.search.projectCode.name, '')
    setValue(formSchema.search.projectName.name, '')

    callApiSearch('', '', pages, display)
  }

  const onSubmitExport = (data) => {
    console.log('onSubmitExport => ', data.projectCode)

    handleExportFile(data.projectCode)
  }

  const handleExportFile = async (ProjectCode) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const file = await exportConfirmActualResult(ProjectCode)

      if (file) {
        downloadFile(
          file,
          file.name || `รายงานเปรียบเทียบความสอดคล้องเป้าหมายยุทธศาสตร์_${ProjectCode}.xlsx`
        )
      }
    } catch (e) {
      console.error('err => ', e)
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      {formSchema && (
        <Panel
          shaded
          header={props?.header || ''}
          collapsible
          defaultExpanded
          ref={(section) => {
            setSection(section)
          }}
        >
          {isLoading && <OverlayLoader />}
          <div style={{ paddingRight: 80, paddingLeft: 80, paddingBottom: 40 }}>
            <Row>
              {formSchema?.search?.projectCode && (
                <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <ControlLabel>{formSchema.search.projectCode.label}</ControlLabel>
                  <Input
                    name={formSchema.search.projectCode.name}
                    defaultValue={formSchema.search.projectCode.value}
                    placeholder={formSchema.search.projectCode.label || ''}
                    inputRef={register()}
                  />
                </Col>
              )}

              {formSchema?.search?.projectName && (
                <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <ControlLabel>{formSchema.search.projectName.label}</ControlLabel>
                  <Input
                    name={formSchema.search.projectName.name}
                    defaultValue={formSchema.search.projectName.value}
                    placeholder={formSchema.search.projectName.label || ''}
                    inputRef={register()}
                  />
                </Col>
              )}
            </Row>

            <Row style={{ marginTop: 15 }}>
              <Col lg={24} md={24} sm={24} xs={24}>
                {/* <hr /> */}
                {formSchema?.search?.searchButtonName && (
                  <SaveButton
                    children={formSchema.search.searchButtonName}
                    onClick={handleSubmit(onSubmit)}
                  />
                )}

                {formSchema?.search?.cancelButtonName && (
                  <CancelButton
                    children={formSchema.search.cancelButtonName}
                    onClick={handleSubmit(onCancel)}
                  />
                )}
              </Col>
            </Row>
          </div>

          <div>
            {/* {formSchema?.search?.excelButtonName && (
              <Row>
                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <SaveButton
                    icon="file-excel-o"
                    children={formSchema.search.excelButtonName}
                    // onClick={handleSubmit(onSubmitExport)}
                  />
                </Col>
              </Row>
            )} */}

            <Table
              height={400}
              data={dataTable || []}
              // onRowClick={(data) => {
              //   console.log(data)
              // }}
              wordWrap
            >
              <Column width={90} align="center">
                <HeaderCell>ลำดับ</HeaderCell>
                <Cell dataKey="rowNumber" />
              </Column>

              <Column width={150} align="center">
                <HeaderCell>รหัสโครงการ</HeaderCell>
                <Cell dataKey="projectCode" />
              </Column>

              <Column width={150} align="center">
                <HeaderCell>เลขที่ข้อตกลง</HeaderCell>
                <Cell dataKey="contractNo" />
              </Column>

              <Column minWidth={300} flexGrow={1}>
                <HeaderCell>ชื่อโครงการ</HeaderCell>
                <Cell dataKey="projectName" />
              </Column>

              <Column width={200} align="center" fixed="right">
                <HeaderCell>Action</HeaderCell>

                <Cell>
                  {(rowData) => {
                    return (
                      <ButtonToolbar>
                        <SaveButton
                          size="sm"
                          icon="file-excel-o"
                          children={formSchema.search.excelButtonName}
                          onClick={() => {
                            // console.log('export excel ', rowData)
                            onSubmitExport(rowData)
                          }}
                        />
                        {/* <IconButton
                          size="sm"
                          appearance="ghost"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                          // onClick={() => {
                          //   sessionStorage.setItem('projectId', rowData.projectId)
                          //   sessionStorage.setItem('param', '')

                          //   history.push(`${pathname.proposal.overview.overviewCoworker}`)
                          // }}
                          style={{ marginTop: -5 }}
                        >
                          แสดง{lengthMenu}
                          {defaultLengthMenu}
                        </IconButton> */}
                      </ButtonToolbar>
                    )
                  }}
                </Cell>
              </Column>
            </Table>

            <TablePagination
              lengthMenu={lengthMenu || viewSize}
              activePage={page || defaultPage}
              renderLengthMenu={(lengthMenu) => {
                return (
                  <>
                    {lengthMenu}
                    {`รายการ/หน้า`}
                  </>
                )
              }}
              renderTotal={(total) => {
                return <>{` ทั้งหมด ${total || 0} รายการ`}</>
              }}
              displayLength={displayLength}
              total={formSchema.totalSize || 0}
              onChangePage={handleChangePage}
              onChangeLength={handleChangeLength}
            />
          </div>
        </Panel>
      )}
    </>
  )
}
